const SortingType = { Ascending: 0, Descending: 1 };

export { SortingType };
